module.exports = __webpack_public_path__ + "fonts/Rubik-400-cyrillic15.8191f79.woff2";